import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const DeleteAccountModal = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-account-dialog-title"
    >
      <DialogTitle
        id="delete-account-dialog-title"
        sx={{ m: 0, pt: 3, pb: 1, position: "relative", fontSize: "18px" }}
      >
        Are You Sure You Want to Delete Your Account?
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 1.5,
            right: 6,
            backgroundColor: "#f0f0f0",
            borderRadius: "50px",
            padding: "4px",
            "&:hover": {
              backgroundColor: "rgba(229, 229, 229, 1)",
            },
          }}
        >
          <CloseIcon sx={{ fontSize: 16, color: "black" }} />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 0, pb: 2 }}>
        <Typography
          className="text-center"
          variant="body2"
          color="text.secondary"
          sx={{ mt: 0 }}
        >
          The Influencer will no longer be able to view it.
        </Typography>
      </DialogContent>

      <DialogActions className="align-items-center justify-content-center">
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            border: "1px solid rgba(107, 142, 118, 1)",
            color: "rgba(107, 142, 118, 1)",
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            backgroundColor: "rgba(199, 27, 27, 1)",
            border: "transparent",
            color: "#fff",
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAccountModal;
